export class UserNotAuthorizedError extends Error {
    constructor() {
        super('User is not authorized');
        this.name = 'UserNotAuthorizedError';
    }
}
